import { useEffect, useState } from "react";

const HEX_RE = /^#[0-9a-fA-F]{6}$/;

export default function ColorPicker({ label = "Color", value, onChange, fallback = "#0A84FF", test = "color-picker" }) {
  const safeValue = isValidHex(value) ? value : fallback;
  const [draft, setDraft] = useState(value || fallback);

  useEffect(() => {
    setDraft(value || fallback);
  }, [fallback, value]);

  const commit = (next) => {
    setDraft(next);
    if (isValidHex(next)) onChange(next);
  };

  const normalize = () => {
    if (!isValidHex(draft)) {
      setDraft(fallback);
      onChange(fallback);
    }
  };

  return (
    <div data-testid={test}>
      <div className="label-eyebrow mb-1.5">{label}</div>
      <div className="flex items-center gap-2">
        <label className="relative h-9 w-9 rounded border border-[hsl(var(--border))] shrink-0 overflow-hidden cursor-pointer" style={{ background: safeValue }} title={`${safeValue} - click to change`}>
          <input
            type="color"
            value={safeValue}
            onChange={(e) => commit(e.target.value)}
            className="absolute inset-0 opacity-0 cursor-pointer"
            aria-label={`${label} browser picker`}
          />
        </label>
        <input
          value={draft}
          onChange={(e) => commit(e.target.value)}
          onBlur={normalize}
          placeholder={fallback}
          className={`w-full h-9 bg-[hsl(var(--surface-2))] border rounded px-3 py-2 text-sm font-mono ${isValidHex(draft) ? "border-[hsl(var(--border))]" : "border-[hsl(var(--destructive))]"}`}
          aria-label={`${label} hex value`}
        />
      </div>
      {!isValidHex(draft) && <div className="text-xs text-[hsl(var(--destructive))] mt-1">Use a hex color like #0A84FF.</div>}
    </div>
  );
}

function isValidHex(value) {
  return HEX_RE.test(value || "");
}
